import { StaticQuery, graphql } from "gatsby"

import { Link } from "gatsby"
import React from "react"
import Search from "../search"

const SubNavbar = ({ setSearchQuery, stackPages, stackMenuLabels }) => {

  const subMenu = [
    { name: stackMenuLabels['stacks'] ?? 'All', route: '/stacks/' },
    { name: stackMenuLabels['sources'] ?? stackPages?.sources?.title ?? 'Sources', route: '/stacks/sources/' },
    { name: stackMenuLabels['destinations'] ?? stackPages?.destinations?.title ?? 'Destinations', route: '/stacks/destinations/' },
    { name: stackMenuLabels['analyses'] ?? stackPages?.analyses?.title ?? 'Analyses', route: '/stacks/analyses/' },
  ];
  return (
    <StaticQuery
      query={graphql`
      query ALL_CONTENT_NODES {
        allWpContentNode(
          sort: { fields: modifiedGmt, order: DESC }
          filter: { nodeType: { ne: "MediaItem" } }
        ) {
          nodes {
            nodeType
            id
            slug
            link
          }
        }
      }
      `}

      render={(data) => {
        return (
          <nav className="flex w-full text-white lg:w-auto  md:space-x-1 lg:space-x-5 xl:space-x-5 2xl:space-x-10">
            <div className="hidden lg:flex lg:items-center md:space-x-1 lg:space-x-5 xl:space-x-5 2xl:space-x-10">
              {
                subMenu.map((menu, key) => {
                  return (
                    <Link key={key} className={
                      `font-medium p-3 rounded`}
                      to={menu.route}
                      activeClassName="bg-sub-secondary font-bold"
                    >{menu.name}</Link>
                  )
                })
              }
            </div>
            <div className="w-full rounded-md lg:w-auto sm:flex lg:space-x-2 sm:justify-end lg:justify-none sm:items-center sm:ml-auto lg:block lg:space-x-0">
              <Search searchTitle={'Search Stacks'} setSearchQuery={setSearchQuery} />
            </div>
          </nav>
        )
      }}
    />
  )
}

export default SubNavbar
